import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Button, Table, TableHead, TableBody, TableRow, TableCell,
  DialogTitle, Box,
  Typography,
  TextField,
  FormControl,
  Select,
  MenuItem,
} from '@material-ui/core';
import {
  Search, Add, Refresh, NavigateNext,
} from '@material-ui/icons';
import { getMessage } from '../../../common/util';
import { ERROR } from '../../../common/message';
import {
  setProductsPopFlg,
  setProductSearchCondition,
  searchProductList,
  setBusinessType,
  getGyotaiMaster,
  setSelectBusinessType,
  setProductsCondition,
  setProductAddCondition,
  setErrMsgProductDuplicate,
  setErrMsgProductKeyword,
  setCheckProductKeyword,
  setProductDisplayCondition,
  setProductResultList,
  getAtsukaihinMulti,
  setGetProductFlg,
} from '../../actions/TargetAction';
import {
  setSystemLodingFLg,
} from '../../actions/CommonAction';
import validator from '../../../common/validator';
import {
  SHUBETSU_CODE,
  GET_MASTER_FLG,
  ADD_LIMIT_COUNT,
} from '../../../common/const';
import styles from './PopStyles.module.css';

class TargetPopSearchProductsComponent extends Component {
  componentDidMount = async () => {
    const {
      getGyotaiMasterAct,
      getAtsukaihinMultiAct,
      setBusinessTypeAct,
      setProductAddConditionAct,
      productsPopFlg,
      productsCondition,
      setProductsConditionAct,
      setProductDisplayConditionAct,
      getProductFlg,
      setGetProductFlgAct,
    } = this.props;

    // 業態リストを取得
    const ret = await getGyotaiMasterAct(SHUBETSU_CODE.CD0008);
    if (ret) {
      setBusinessTypeAct(ret.code_list);
    }

    // 扱い品取得
    if (productsPopFlg && getProductFlg === GET_MASTER_FLG.ON) {
      const productsRes = await getAtsukaihinMultiAct(productsCondition);
      if (productsRes) {
        // 選択内容を編集して検索条件にセット
        const setProductCondition = [];
        productsRes.result_list.forEach((condition) => {
          const newSetProductCondition = {
            agcd: condition.code,
          };
          setProductCondition.push(newSetProductCondition);
        });

        setProductsConditionAct(setProductCondition);
        setProductAddConditionAct(productsRes.result_list);
        setProductDisplayConditionAct(productsRes.result_list);
        setGetProductFlgAct(GET_MASTER_FLG.OFF);
      }
    }
  }

  /**
   * キーワード値変更
   */
  onChangeSearchCondition = (val) => {
    const { setProductSearchConditionAct } = this.props;
    setProductSearchConditionAct(val);
  }

  /**
   * 業態リスト選択値変更
   */
  onChangeBusinessType = async (ev) => {
    const {
      setSelectBusinessTypeAct,
    } = this.props;

    const selectedList = [];

    const item = {
      code: ev.target.value,
      name: ev.nativeEvent.target.innerText,
    };

    selectedList.push(item);

    setSelectBusinessTypeAct(selectedList);
  }

  /**
   * 扱い品選択POPUPをclose
   */
  closeProductsPop = () => {
    const { setProductsPopFlgAct } = this.props;
    setProductsPopFlgAct(false);
  };

  /**
 * 検索ボタン押下
 */
  searchProductList = async () => {
    const {
      searchProductCondition,
      selectBusinessType,
      setSystemLodingFLgAct,
      searchProductListAct,
      setErrMsgProductDuplicateAct,
    } = this.props;

    // エラーメッセージを初期化
    setErrMsgProductDuplicateAct();

    // 検索条件が入力されている場合、スペース除去
    const searchWord = searchProductCondition
      ? searchProductCondition.trim() : searchProductCondition;

    // エンターキー連打制御
    document.activeElement.blur();
    setSystemLodingFLgAct(true);

    let businessTypeCode = '';
    if (selectBusinessType[0]) {
      businessTypeCode = selectBusinessType[0].code;
    }

    await searchProductListAct(searchWord, businessTypeCode);
    setSystemLodingFLgAct(false);
  }

  /**
   * 条件クリアボタン押下
   */
  clear = () => {
    const {
      setProductSearchConditionAct,
      setSelectBusinessTypeAct,
      setErrMsgProductKeywordAct,
      setCheckProductKeywordAct,
      setErrMsgProductDuplicateAct,
      setProductResultListAct,
    } = this.props;

    // 検索条件を初期化
    setProductSearchConditionAct();
    setSelectBusinessTypeAct();
    setProductResultListAct();

    // キーワード桁数チェック
    // エラーメッセージ、エラーフラグを解除
    setErrMsgProductKeywordAct();
    setCheckProductKeywordAct(false);
    setErrMsgProductDuplicateAct();
  }

  /**
   * 追加ボタン押下
   */
  addProduct = (index) => {
    const {
      productResultList,
      productAddCondition,
      setProductAddConditionAct,
      setErrMsgProductDuplicateAct,
    } = this.props;

    const addList = productResultList.search_atsukaihin_list.filter((v, id) => id === index);

    const addProductConditionList = [];
    let addItem;
    addList.forEach((item) => {
      if (!item.atsukaihin_name) {
        addItem = {
          code: item.atsukaihin_code + item.gyotai_code,
          condition: item.gyotai_name,
        };
      } else if (!item.gyotai_name) {
        addItem = {
          code: item.atsukaihin_code + item.gyotai_code,
          condition: item.atsukaihin_name,
        };
      } else if (item.gyotai_name && item.atsukaihin_name) {
        addItem = {
          code: item.atsukaihin_code + item.gyotai_code,
          condition: `${item.atsukaihin_name}：${item.gyotai_name}`,
        };
      }
      // 追加条件リストにセット
      addProductConditionList.push(addItem);
    });

    if (productAddCondition) {
      // 選択内容に値が設定されている場合

      // 選択内容リスト
      const selectedConditionList = [];
      productAddCondition.forEach((item) => selectedConditionList.push(item));

      // 重複チェック
      const msgs = [];

      addProductConditionList.forEach((item) => {
        // 追加条件リストの内容をチェックして、重複しないものだけ選択内容リストに追加
        if (!selectedConditionList.some((selectItem) => selectItem.code === item.code)) {
          if (selectedConditionList.length === ADD_LIMIT_COUNT.PRODUCT) {
            setErrMsgProductDuplicateAct(getMessage(ERROR.E02005));
          } else {
            selectedConditionList.push(item);
            setErrMsgProductDuplicateAct();
          }
        } else {
          // 重複している場合、エラーメッセージを表示
          setErrMsgProductDuplicateAct(getMessage(ERROR.E02004, msgs.join(',')));
        }
      });
      setProductAddConditionAct(selectedConditionList);
    } else {
      // 選択内容に値が設定されていない場合
      // エラーメッセージを初期化
      setErrMsgProductDuplicateAct();
      setProductAddConditionAct(addProductConditionList);
    }
  }

  /**
   * 全て選択ボタン押下
   */
  addAllProduct = () => {
    const {
      productResultList,
      productAddCondition,
      setProductAddConditionAct,
      setErrMsgProductDuplicateAct,
    } = this.props;

    // 検索結果がnullかつ空では無い場合
    if (productResultList && Object.keys(productResultList).length !== 0) {
      const addProductConditionList = [];
      let addItem;
      productResultList.search_atsukaihin_list.forEach((item) => {
        if (!item.atsukaihin_name) {
          addItem = {
            code: item.atsukaihin_code + item.gyotai_code,
            condition: item.gyotai_name,
          };
        } else if (!item.gyotai_name) {
          addItem = {
            code: item.atsukaihin_code + item.gyotai_code,
            condition: item.atsukaihin_name,
          };
        } else if (item.gyotai_name && item.atsukaihin_name) {
          addItem = {
            code: item.atsukaihin_code + item.gyotai_code,
            condition: `${item.atsukaihin_name}：${item.gyotai_name}`,
          };
        }
        addProductConditionList.push(addItem);
      });

      if (productAddCondition) {
        // 選択内容に値が設定されている場合

        // 選択内容リスト
        const selectedConditionList = [];
        productAddCondition.forEach((item) => selectedConditionList.push(item));

        // 重複チェック
        let hasDuplicate = false;
        const msgs = [];

        addProductConditionList.forEach((item) => {
          // 追加条件リストの内容をチェックして、重複しないものだけ選択内容リストに追加
          if (!selectedConditionList.some((selectItem) => selectItem.code === item.code)) {
            selectedConditionList.push(item);
          } else {
            // 重複データが存在する場合
            hasDuplicate = true;
          }
        });

        if (selectedConditionList.length > ADD_LIMIT_COUNT.PRODUCT) {
          setErrMsgProductDuplicateAct(getMessage(ERROR.E02005));
        } else {
          if (hasDuplicate) {
            // 重複データが存在する場合
            // エラーメッセージを設定
            setErrMsgProductDuplicateAct(getMessage(ERROR.E02004, msgs.join(',')));
          } else {
            // 重複データが存在しない場合
            // エラーメッセージを初期化
            setErrMsgProductDuplicateAct();
          }

          setProductAddConditionAct(selectedConditionList);
        }
      } else if (addProductConditionList.length > ADD_LIMIT_COUNT.PRODUCT) {
        setErrMsgProductDuplicateAct(getMessage(ERROR.E02005));
      } else {
        // 選択内容に値が設定されていない場合
        // エラーメッセージを初期化
        setErrMsgProductDuplicateAct();
        setProductAddConditionAct(addProductConditionList);
      }
    }
  }

  /**
   * 削除ボタン押下
   */
  deleteProduct = (code) => {
    const {
      productAddCondition,
      setProductAddConditionAct,
      setErrMsgProductDuplicateAct,
    } = this.props;

    // エラーメッセージを初期化
    setErrMsgProductDuplicateAct();

    const newProductAddCondition = productAddCondition
      .filter((condition) => condition.code !== code);
    setProductAddConditionAct(newProductAddCondition);
  }

  /**
   * 設定ボタン押下
   */
  setCondition = () => {
    const {
      setProductDisplayConditionAct,
      setProductsConditionAct,
      productAddCondition,
      setSelectBusinessTypeAct,
      setProductSearchConditionAct,
      setProductResultListAct,
      setErrMsgProductKeywordAct,
      setErrMsgProductDuplicateAct,
      setCheckProductKeywordAct,
    } = this.props;

    const setProductCondition = [];

    // 選択内容一覧がnullではない場合
    if (productAddCondition) {
      // 選択内容を編集して検索条件にセット
      productAddCondition.forEach((condition) => {
        const newSetProductCondition = {
          agcd: condition.code,
        };
        setProductCondition.push(newSetProductCondition);
      });

      setProductsConditionAct(setProductCondition);
      setProductDisplayConditionAct(productAddCondition);

      // 検索条件、検索結果、エラーメッセージ初期化
      setSelectBusinessTypeAct();
      setProductSearchConditionAct();
      setProductResultListAct();
      setErrMsgProductKeywordAct();
      setErrMsgProductDuplicateAct();
      setCheckProductKeywordAct(false);

      // ポップアップを閉じる
      this.closeProductsPop();
    }
  }

  /**
  *扱い品キーワード 最大桁数のチェック
  */
  onBlurKeyword = () => {
    const {
      searchProductCondition,
      setCheckProductKeywordAct,
      setErrMsgProductKeywordAct,
    } = this.props;

    // 入力チェック
    const msgs = [];
    validator.checkMaxLength(searchProductCondition, 25, msgs);

    if (msgs.length !== 0) {
      // エラー有りの場合
      // エラーメッセージ、エラーフラグを設定
      setErrMsgProductKeywordAct(getMessage(ERROR.E08009, msgs.join(',')));
      setCheckProductKeywordAct(true);
      return;
    }

    // エラー無しの場合
    // エラーメッセージ、エラーフラグを解除
    setErrMsgProductKeywordAct();
    setCheckProductKeywordAct(false);
  }

  /**
   * キャンセルボタン押下
   */
  cancel = () => {
    const {
      setSelectBusinessTypeAct,
      setProductSearchConditionAct,
      setProductResultListAct,
      setErrMsgProductKeywordAct,
      setErrMsgProductDuplicateAct,
      setCheckProductKeywordAct,
    } = this.props;

    // 検索条件、検索結果、エラーメッセージ初期化
    // 検索条件、検索結果、エラーメッセージ初期化
    setSelectBusinessTypeAct();
    setProductSearchConditionAct();
    setProductResultListAct();
    setErrMsgProductKeywordAct();
    setErrMsgProductDuplicateAct();
    setCheckProductKeywordAct(false);

    // ポップアップを閉じる
    this.closeProductsPop();
  }

  render() {
    const {
      checkErrFlg,
      productsPopFlg,
      searchProductCondition,
      businessType,
      selectBusinessType,
      productResultList,
      productAddCondition,
      errMsgProductKeyword,
      errMsgProductDuplicate,
    } = this.props;

    // 各セレクトボックスに選択中のコードを設定
    const businessTypeCodeList = [];
    selectBusinessType.map((item) => businessTypeCodeList.push(item.code));

    return (productsPopFlg && (
      <Box className={`${styles.dialog}`}>
        <Box className={`${styles.contents}`}>
          <Box className={`${styles.marginBottomHalf}`}>
            <DialogTitle>扱い品選択</DialogTitle>
          </Box>
          <Box className={`${styles.height2}`}>
            <span className={`${styles.errorMsg}`}>{errMsgProductDuplicate}</span>
          </Box>
          <Box className={`${styles.searchconditionarea}`}>
            <Box className={`${styles.condition}`}>
              <Box className={`${styles.conditionTitle}`}>キーワード</Box>
              <Box className={`${styles.conditionValue}`}>
                <TextField
                  inputProps={{
                    className: `${styles.inputSizing}`,
                  }}
                  onBlur={this.onBlurKeyword}
                  value={searchProductCondition || ''}
                  onChange={(ev) => this.onChangeSearchCondition(ev.target.value)}
                  onKeyDown={(ev) => {
                    if (ev.key === 'Enter') {
                      this.searchProductList();
                    }
                  }}
                  variant="outlined"
                  error={checkErrFlg.checkProductKeyword}
                />
                {checkErrFlg.checkProductKeyword
                  && (
                    <div className={`${styles.baloon}`}>
                      <div className={`${styles.triangle}`}>
                        <div className={`${styles.triangleDiv}`} />
                      </div>
                      <div className={`${styles.babble}`}>
                        {errMsgProductKeyword}
                      </div>
                    </div>
                  )}
              </Box>
              <Box className={`${styles.conditionTitle}`}>業態</Box>
              <Box className={`${styles.conditionValue}`}>
                <FormControl variant="outlined">
                  <Select
                    value={businessTypeCodeList}
                    onChange={this.onChangeBusinessType}
                    MenuProps={{
                      getContentAnchorEl: null,
                      anchorOrigin: { vertical: 30, horizontal: 0 },
                      PaperProps: {
                        className: styles.selectStyle,
                      },
                    }}
                  >
                    <MenuItem key="" value="">　</MenuItem>
                    {businessType
                      && businessType.map((BusinessType) => (
                        <MenuItem
                          key={BusinessType.cdshbtch}
                          value={BusinessType.cdshbtch}
                        >
                          {BusinessType.cdch_im}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Box>
              <Box className={`${styles.conditionButton}`}>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<Refresh />}
                  onClick={() => this.clear()}
                  className={`${styles.height2}`}
                >
                  条件クリア
                </Button>
              </Box>
              <Box className={`${styles.conditionButton}`}>
                <Button
                  variant="contained"
                  color="secondary"
                  startIcon={<Search />}
                  onClick={() => this.searchProductList(selectBusinessType, searchProductCondition)}
                  disabled={checkErrFlg.checkProductKeyword}
                  className={`${styles.height2}`}
                >
                  検索
                </Button>
              </Box>
            </Box>
          </Box>
          <Box className={`${styles.searchResultarea}`}>
            <div className={`${styles.searchResultareaTableHead}`}>
              <Table className={`${styles.tableLayoutFixed}`}>
                <TableHead>
                  <TableRow>
                    <TableCell className={`${styles.dialogTableHeader} ${styles.dialogTableCell} ${styles.searchResultareaHeader} ${styles.addDeleteCell}`}> </TableCell>
                    <TableCell className={`${styles.dialogTableHeader} ${styles.dialogTableCell} ${styles.searchResultareaHeader}`}>扱い品名</TableCell>
                    <TableCell className={`${styles.dialogTableHeader} ${styles.dialogTableCell} ${styles.searchResultareaHeader}`}>業態</TableCell>
                    <TableCell className={`${styles.dialogTableHeader} ${styles.dialogTableCell} ${styles.searchResultareaHeader}`}>業種</TableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </div>
            <div className={`${styles.searchResultareaTableBody}`}>
              <Table className={`${styles.tableLayoutFixed}`}>
                <TableBody>
                  {productResultList
                    && productResultList.search_atsukaihin_list
                    && productResultList.search_atsukaihin_list.map((result, index) => (
                      <TableRow key={index}>
                        <TableCell className={`${styles.dialogTableCell} ${styles.addDeleteCell}`}>
                          <Button
                            onClick={() => this.addProduct(index)}
                            variant="contained"
                            className={`${styles.tooltip} addDelete`}
                          >
                            <span>＋</span>
                            <Box className={`${styles.description}`}>検索条件に追加</Box>
                          </Button>
                        </TableCell>
                        <TableCell className={`${styles.dialogTableCell}`}>{result.atsukaihin_name}</TableCell>
                        <TableCell className={`${styles.dialogTableCell}`}>{result.gyotai_name}</TableCell>
                        <TableCell className={`${styles.dialogTableCell}`}>{result.fine_classification_name}</TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </div>
          </Box>
          <Box className={`${styles.listSpacerArea}`}>
            <Box className={`${styles.addAllArea}`}>
              <Button
                variant="contained"
                onClick={() => this.addAllProduct()}
                startIcon={<Add />}
                className={`${styles.displayFlex} ${styles.height2} addAll`}
              >
                全て選択
              </Button>
            </Box>
            <Box className={`${styles.arrowDown}`}>
              <Typography className={`${styles.fontSize}`}>≫</Typography>
            </Box>
          </Box>
          <Box className={`${styles.productsCondition}`}>
            <div className={`${styles.productsconditionTableHead}`}>
              <Table className={`${styles.tableLayoutFixed}`}>
                <TableHead>
                  <TableRow>
                    <TableCell className={`${styles.dialogTableHeader} ${styles.dialogTableCell} ${styles.conditionlistHeader} ${styles.addDeleteCell}`}> </TableCell>
                    <TableCell className={`${styles.dialogTableHeader} ${styles.dialogTableCell} ${styles.conditionlistHeader}`}>選択内容</TableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </div>
            <div className={`${styles.productsconditionTableBody}`}>
              <Table className={`${styles.tableLayoutFixed}`}>
                <TableBody>
                  {productAddCondition
                    && productAddCondition.map((selectCondition, i) => (
                      <TableRow key={i}>
                        <TableCell className={`${styles.dialogTableCell} ${styles.addDeleteCell}`}>
                          <Button
                            variant="contained"
                            className={`${styles.tooltip} addDelete`}
                            onClick={() => this.deleteProduct(selectCondition.code)}
                          >
                            <span>－</span>
                            <Box className={`${styles.description}`}>検索条件から削除</Box>
                          </Button>
                        </TableCell>
                        <TableCell className={`${styles.dialogTableCell}`}>{selectCondition.condition}</TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </div>
          </Box>
          <Box className={`${styles.buttonArea}`}>
            <Button
              variant="contained"
              className={`${styles.height2} cancel`}
              onClick={() => this.cancel()}
            >
              キャンセル
            </Button>
            <Button
              variant="contained"
              color="secondary"
              className={`${styles.marginLeft1} ${styles.height2}`}
              onClick={() => this.setCondition()}
            >
              <NavigateNext className={`${styles.setButtonIcon}`} />
              設定
            </Button>
          </Box>
        </Box>
      </Box>
    ));
  }
}

export default connect(
  (state) => ({
    searchProductCondition: state.target.searchProductCondition,
    // 扱い品選択POP表示フラグ
    productsPopFlg: state.target.productsPopFlg,
    businessType: state.target.businessType,
    selectBusinessType: state.target.selectBusinessType,
    productResultList: state.target.productResultList,
    productsCondition: state.target.productsCondition,
    productAddCondition: state.target.productAddCondition,
    checkErrFlg: state.target.checkErrFlg,
    errMsgProductKeyword: state.target.errMsgProductKeyword,
    errMsgProductDuplicate: state.target.errMsgProductDuplicate,
    productDisplayCondition: state.target.productDisplayCondition,
    getProductFlg: state.target.getProductFlg,
  }),
  (dispatch) => ({
    setProductSearchConditionAct: (str) => dispatch(setProductSearchCondition(str)),
    setBusinessTypeAct: (obj) => dispatch(setBusinessType(obj)),
    getGyotaiMasterAct: (shubetsuCode) => dispatch(getGyotaiMaster(shubetsuCode)),
    setProductsPopFlgAct: (bool) => dispatch(setProductsPopFlg(bool)),
    searchProductListAct: (searchWord, selectBusinessType) => dispatch(searchProductList(searchWord,
      selectBusinessType)),
    setSystemLodingFLgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
    setSelectBusinessTypeAct: (obj) => dispatch(setSelectBusinessType(obj)),
    setProductsConditionAct: (obj) => dispatch(setProductsCondition(obj)),
    setProductAddConditionAct: (obj) => dispatch(setProductAddCondition(obj)),
    setErrMsgProductDuplicateAct: (sr) => dispatch(setErrMsgProductDuplicate(sr)),
    setErrMsgProductKeywordAct: (sr) => dispatch(setErrMsgProductKeyword(sr)),
    setCheckProductKeywordAct: (bool) => dispatch(setCheckProductKeyword(bool)),
    setProductDisplayConditionAct: (obj) => dispatch(setProductDisplayCondition(obj)),
    setProductResultListAct: (obj) => dispatch(setProductResultList(obj)),
    getAtsukaihinMultiAct: (obj) => dispatch(getAtsukaihinMulti(obj)),
    setGetProductFlgAct: (string) => dispatch(setGetProductFlg(string)),
  }),
)(TargetPopSearchProductsComponent);
